import { IAjaxHelperConfig } from './iajax_helper_config';
import { Util } from '../common_utils/util';
//import * as $ from 'jquery';
import { IAjaxMetrics } from './iajax_metrics';
import { IClientConfig } from '../aggr_module/data_manager/data_manager_factory'


/**
 * Responsible to construct the configuration object required for the Ajax communication
 * @export
 * @class AjaxHelperConfig
 * @implements {IAjaxHelperConfig}
 */
export class AjaxHelperConfig implements IAjaxHelperConfig {
    // avoiding cyclic redencency error
    static corsProxySettings = { domainUrl: '', url: '', iscorsRequired: true, isCorsRequested: false };// * If we need cors settings
    // {domainUrl: www.cvs.com/photo or www.snapfish.com , url: www.snapfish.com/library or www.cvs.com/photo/library  }
    static enableApiHitWithMainHost = false;

    static setCorsProxySettings(url: string, isRequired: boolean): void {
        this.corsProxySettings = { domainUrl: Util.getHostDomain(), url, iscorsRequired: isRequired, isCorsRequested: false };
    }
    
    static setGlobalConfiguration(config: IClientConfig) {
        this.enableApiHitWithMainHost = config.enableApiHitWithMainHost;
    }

    static corsRequested() {
        this.corsProxySettings.isCorsRequested = true;
    }

    static getCorsProxySettings(): { domainUrl: string, url: string, iscorsRequired: boolean, isCorsRequested: boolean } {
        return this.corsProxySettings;
    }

    static getCorsProxyUrl(): string {
        return this.getCorsProxySettings().url + '/corsproxy';
    }

    requestConfig = {
        url: '',
        type: 'GET',
        dataType: 'JSON',
        payload: {},
        async: true,
        cache: false,
        beforeSend(jqXHR: object, settings: object) {},
        headers: { 'GSID': '', 'Authorization': '', 'Content-Type': 'application/json','Noodle':Util.getUUID() },
        params: {},
        data:"{}",
        ignoreAToken:false,
        serviceHostUrl: ""
    };
    options = {
        encryptit: false,
        needRefreshAccessToken: true,// 401 case - wrong album access public-share, normal oa2 cookie failure case
        isGSIDHeaderRequired: true,// Few of back-end services not require GSID
        isEncryptRequired: true,// used in initiateShareGrantSuccess
        requireRetryOn404StatusCode: false,// used for triggerTestFileVirusScan - DP handler
        isAuthorizationRequired: true,// used for public share flow dont fetch token : value is false
        includeHeaders: true,// dpHandler
        convertToBaseDomain: true,// cvs.com,projects_url, accounts_url
        retryWithNoodle: true// for 3rd iteration if projects_url
    };

    private requestStartTime: number = 0;
    private iterationCount: number = 0;
    private promiseRef: any;

    setPromiseRef(promiseRef: any) {
        this.promiseRef = promiseRef;
    }

    getPromiseRef() {
        return this.promiseRef;
    }

    setRequestStartTime(startTime: number = 0): void {
        if (startTime) {
            this.requestStartTime = startTime;
        }

    }

    getRequestStartTime(): number {
        return this.requestStartTime;
    }

    getIterationCount(): number {
        return this.iterationCount;
    }

    getNoodle(): string {
        return this.requestConfig.headers.Noodle;
    }

    incrementIterationCount(): void {
        ++this.iterationCount;
    }

}
